module.exports = __webpack_public_path__ + "static/media/SteelSection.c0e37359.svg";